// @flow

import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import type { MatchType } from 'types/Competitions';
import { getRencontresDateFormat, doesLocalTeamWon, doesChallengerTeamWon } from 'utils/rencontreUtils';
import { shouldUsePlaceholder } from 'utils/assetsUtils';

type Props = {
  rencontres: Array<MatchType>,
  equipeNom: string,
  title: string,
  spaceTitle?: boolean
};

export default class ResultatListItem extends Component<Props> {
  renderResultatsCards = () => {
    const { rencontres } = this.props;
    if (rencontres) {
      return rencontres.map<any>(rencontre => {
        const {
          adversaire,
          reception,
          journee,
          france_score,
          adversaire_score,
          link,
          embleme_france,
          france_drapeau,
          adversaire_drapeau,
          embleme_adversaire,
          adversaire_logo,
          france_logo,
          date_rencontre
        } = rencontre;

        let logoFrance = embleme_france ? embleme_france : france_logo;
        let logoAdversaire = embleme_adversaire ? embleme_adversaire : adversaire_logo;
        const isJournee = journee !== '' && journee !== 0 && journee !== '0';
        const francePlaysAtHome = reception && reception !== 0;

        return (
          <Fragment
            key={`NextMatch ${
              francePlaysAtHome ? 'France/' + adversaire : adversaire + '/France'
            } ${date_rencontre}`}
          >
            <p className="block-competition__head ft-h6 ft-up mb-1">
              {isJournee && `Journée ${journee} — `} {getRencontresDateFormat(date_rencontre)}
            </p>
            <Link
              className="match box box--white mb-2"
              to={link}
              title={`Voir les informations du match ${
                francePlaysAtHome ? 'France/' + adversaire : adversaire + '/France'
              }`}
            >
              <div className="match__club">
                <p className={doesLocalTeamWon({ adversaire_score, france_score }, reception)}>
                  {francePlaysAtHome ? 'France' : adversaire}
                  <img
                    src={shouldUsePlaceholder(
                      {
                        embleme_adversaire: logoAdversaire || adversaire_drapeau,
                        embleme_france: logoFrance || france_drapeau,
                        reception
                      },
                      true
                    )}
                    alt={`Logo ${francePlaysAtHome ? 'France' : adversaire}`}
                    width="24"
                    height="24"
                  />
                </p>
              </div>
              <div className="match__info">
                <p className="match__score">
                  <span className={doesLocalTeamWon({ adversaire_score, france_score }, reception)}>
                    {francePlaysAtHome ? france_score : adversaire_score}
                  </span>
                  <span className="match__colon">:</span>
                  <span className={doesChallengerTeamWon({ adversaire_score, france_score }, reception)}>
                    {francePlaysAtHome ? adversaire_score : france_score}
                  </span>
                </p>
              </div>
              <div className="match__club">
                <p className={doesChallengerTeamWon({ adversaire_score, france_score }, reception)}>
                  <img
                    src={shouldUsePlaceholder(
                      {
                        embleme_adversaire: logoAdversaire || adversaire_drapeau,
                        embleme_france: logoFrance || france_drapeau,
                        reception
                      },
                      false
                    )}
                    alt={`Logo ${francePlaysAtHome ? adversaire : 'France'}`}
                    width="24"
                    height="24"
                  />
                  {francePlaysAtHome ? adversaire : 'France'}
                </p>
              </div>
            </Link>
          </Fragment>
        );
      });
    }
    return null;
  };

  render() {
    const { title, spaceTitle } = this.props;
    const titleClassName = spaceTitle ? 'mb-3 mt-5' : 'mb-3';
    return (
      <Fragment>
        {title !== '' && <h3 className={titleClassName}>{title}</h3>}
        {this.renderResultatsCards()}
      </Fragment>
    );
  }
}
